// extracted by mini-css-extract-plugin
module.exports = {"root":"o0iOJJIE"};